module.exports = __webpack_public_path__ + "img/vlasov.ea9b1521.png";